export const NutritionalParameter = (json: INutritionalParameter): INutritionalParameterModel => {
	const { id, order, unit, name, short_name, is_required, created_at, updated_at, type } = json

	return {
		id,
		type,
		unit,
		order,
		name: LangContentToModel(name),
		shortName: LangContentToModel(short_name),
		isRequired: is_required,
		updatedAt: updated_at ? new Date(updated_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
	}
}

export const NutritionalParameterWithValue = (
	json: INutritionalParameterWithValue,
): INutritionalParameterWithValueModel => {
	const { id, order, unit, type, name, short_name, is_required, created_at, updated_at, value } = json

	return {
		id,
		order,
		unit,
		type,
		value: Number.isNaN(value) ? 0 : Number(value),
		name: LangContentToModel(name),
		shortName: LangContentToModel(short_name),
		isRequired: is_required,
		updatedAt: updated_at ? new Date(updated_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
	}
}

/**
 * History
 */
export const NutritionalParameterHistory = (json: INutritionalParameterHistory): INutritionalParameterHistoryModel => {
	const { ...rest } = json

	return {
		...rest,
	}
}

/**
 * Payload
 */
export const NutritionalNutrihexPointsToPayload = (
	json: INutritionalNutrihexPoints,
): INutritionalNutrihexPointsPayload => {
	const { glycemicIndex, glycemicLoad, protein, fiber, simpleSugar, salt } = json

	return {
		protein,
		fiber,
		salt,
		glycemic_index: glycemicIndex,
		glycemic_load: glycemicLoad,
		simple_sugars: simpleSugar,
	}
}
